import React, { useContext, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "@windmill/react-ui";
import { FiTrash2 } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { SidebarContext } from "context/SidebarContext";
import useToggleDrawer from "hooks/useToggleDrawer";
import ParkingServices from "services/ParkingServices";
import { notifyError, notifySuccess } from "utils/toast";
import spinnerLoadingImage from "assets/img/spinner.gif";

const ParkingDeleteModal = ({ id, setIsCheck, title, body }) => {
  const { isModalOpen, closeModal, setIsUpdate } = useContext(SidebarContext);
  const { setServiceId } = useToggleDrawer();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsSubmitting(true);

      if (location.pathname === "/parking") {
        const res = await ParkingServices.deleteParking(id, body);

        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
      setServiceId("");
      setIsCheck([]);
      closeModal();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal}>
      <ModalBody className="text-center custom-modal px-8 pt-6 pb-4">
        <span className="flex justify-center text-3xl mb-6 text-red-500">
          <FiTrash2 />
        </span>
        <h2 className="text-xl font-medium mb-2">
            Are You Sure! Want to Delete?
        </h2>
      </ModalBody>

      <ModalFooter className="justify-center">
        <Button
          className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          layout="outline"
          onClick={closeModal}
        >
          No, Keep It
        </Button>

        <div className="flex justify-end">
          {isSubmitting ? (
            <Button disabled className="w-full h-12 sm:w-auto">
              <img
                src={spinnerLoadingImage}
                alt="Loading"
                width={20}
                height={10}
              />
              <span className="font-serif ml-2 font-light">Processing</span>
            </Button>
          ) : (
            <Button onClick={handleDelete} className="w-full h-12 sm:w-auto">
              Yes, Delete It
            </Button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ParkingDeleteModal;
